import { Component, OnInit, EventEmitter, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { ConnectService } from '@app/shared/services/connect.service';
import swal from "sweetalert2";
@Component({
  selector: 'app-remove-connection',
  templateUrl: './remove-connection.component.html',
  styleUrls: ['./remove-connection.component.css'],
  exportAs: 'ConnectionRemoveModal'
})
export class RemoveConnectionComponent implements OnInit {
  @ViewChild('ConnectionRemoveModal') public ConnectionRemoveModal: ModalDirective;
  @Output() refreshAPI: EventEmitter<any> = new EventEmitter();
  conncetionDetails: any = {};
  statusValue: string = '';
  constructor(private connectService: ConnectService) { }

  ngOnInit() {
  }
  showModal(connection, status) {
    this.conncetionDetails = connection;
    this.statusValue = status;
    this.ConnectionRemoveModal.show();
  }
  hideModal() {
    this.ConnectionRemoveModal.hide();
  }
  remove(id, status) {
    if (status === 'withdraw') {
      this.withdrawConnect(id);
    }
    else {
      this.connectDisconnect(id, status);
    }
  }

  connectDisconnect(id, status) {
    this.connectService.updateConnectionStatus(id, status).subscribe(
      (resp: any) => {
        this.hideModal();
        swal("Success", "Request removed successfully.", "success");
        this.refreshAPI.emit();
      },
      error => {
        swal("Info", error.error.error.message, "info");
      }
    )
  }
  withdrawConnect(id) {
    this.connectService.withdrawConnection(id).subscribe(
      (resp: any) => {
        this.hideModal();
        swal("Success", "Request removed successfully.", "success");
        this.refreshAPI.emit();
      }, error => {
        swal("Info", error.error.error.message, "info");
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/remove-connection/remove-connection.component.ts